import { render, staticRenderFns } from "./equipesinscritas.vue?vue&type=template&id=b6c172da"
import script from "./equipesinscritas.vue?vue&type=script&lang=js"
export * from "./equipesinscritas.vue?vue&type=script&lang=js"
import style0 from "./equipesinscritas.vue?vue&type=style&index=0&id=b6c172da&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports